import { render, staticRenderFns } from "./ProfileAboutDescription.vue?vue&type=template&id=3e073415&scoped=true&"
import script from "./ProfileAboutDescription.vue?vue&type=script&lang=js&"
export * from "./ProfileAboutDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e073415",
  null
  
)

export default component.exports